import GeaoVerticalStepperLayout from "../shared/Layout/GeaoVerticalStepperLayout";
import { getProducerFlowVerticalStepperElements } from "../../constants/ProducerFlowVerticalStepperElementsFactory";
import useGtmTracking from "../../../../hooks/useGtmTracking";
import { useContext } from "react";
import { GeaoContext } from "../../GeaoContextProvider";
import { ClientConfigurationContext } from "../../../../context/ClientConfigurationContextProvider";

export default function ProducerApplicationSubmitted() {
    useGtmTracking("Onboarding:AgentCongrats", "onboarding_agent_complete");

    const { agentInterview } = useContext(GeaoContext);
    const clientConfiguration = useContext(ClientConfigurationContext);

    // Get the dynamic vertical stepper with offshore settings
    const enableOffshore = clientConfiguration?.enableOffshore === true;
    const isOffshoreResident = agentInterview?.questionAnswers?.OffshoreResident?.answer === "true";
    const verticalStepperElements = getProducerFlowVerticalStepperElements(enableOffshore, isOffshoreResident);

    return (
        <GeaoVerticalStepperLayout
            verticalStepperElements={verticalStepperElements}
            currentStepperItem="Application Submitted"
            header="Application Submitted"
        >
            <div className="container margin-top">
                <h3 className="mb-5"> Thank you for applying to be an agent with GEICO! </h3>
                <div className="panel-content">
                    <p className="mb-5"> Your application has been submitted.  We'll review your details and contact you when you've been approved to start selling with GEICO.  This typically only takes a few days. </p>
                </div>
            </div>
        </GeaoVerticalStepperLayout>
    );
}
